//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'DCFC_Age',
  data() {
    return {
      form:{
        age_range:'',
        dose:'',
        age:''
      },
      hasScore:false,
      disabled:false,
      dataList1:[
        {value:"0",name:'＜1岁'},
        {value:"1",name:'＞=1岁'}
      ]
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        // ①1岁以内儿童用药剂量=0.01*（月龄＋3）*成人剂量
        // ②1岁以上儿童用药剂量=0.05*（年龄＋2）*成人剂量
        let result = 0
        if (form.age_range == 0) {
          result = 0.01 * (form.age + 3) * form.dose
        } else {
          result = 0.05 * (form.age + 2) * form.dose
        }
        self.hasScore = true
        return String(result.toFixed(2))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/DCFC_Age.vue